import styled from "styled-components";

interface IButtonOrder {
  active: boolean;
}

export const Container = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral2.light};

  @media (min-width: 768px) {
    border: none;
  }
`;

export const ButtonOrder = styled.button<IButtonOrder>`
  padding: 40px 20px;
  font-weight: normal;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.neutral1.light};
  text-transform: lowercase;
  width: 100%;
  background-color: ${(props) =>
    props.active ? "rgba(219, 199, 184, 0.15)" : "transparent"};
  border: none;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    opacity: 0.4;
  }

  @media (min-width: 480px) {
    font-size: 2rem;
    line-height: 40px;
    padding: 40px;
  }

  @media (min-width: 768px) {
    padding: 16px;
    font-size: 0.875rem;
    line-height: 17px;
  }

  > svg {
    > path {
      fill: ${(props) => props.theme.colors.brand1.pure};
    }
    margin-left: 8px;
  }
`;
